// client/src/api/campaignService.js
import api from './api';

// État complet de la campagne (acts, progression, XP, niveau)
export const getCampaign = async () => {
  try {
    const response = await api.get('/campaign');
    return response.data;
  } catch (error) {
    console.error('Error fetching campaign:', error);
    throw error;
  }
};

// Lancer le duel d'un nœud — renvoie { success, gameId }
export const playNode = async (nodeId, deckId, stars) => {
  try {
    const response = await api.post(`/campaign/${nodeId}/play`, { deckId, stars });
    return response.data;
  } catch (error) {
    console.error(`Error playing node ${nodeId}:`, error);
    throw error;
  }
};

// Valider la fin d'un duel de campagne (récompenses si victoire)
export const completeNode = async (nodeId, gameId) => {
  try {
    const response = await api.post(`/campaign/${nodeId}/complete`, { gameId });
    return response.data;
  } catch (error) {
    console.error(`Error completing node ${nodeId}:`, error);
    throw error;
  }
};

// Choisir une option d'événement
export const chooseEvent = async (nodeId, choiceId) => {
  try {
    const response = await api.post(`/campaign/${nodeId}/event`, { choiceId });
    return response.data;
  } catch (error) {
    console.error(`Error choosing event ${nodeId}:`, error);
    throw error;
  }
};

// Ouvrir un trésor
export const openTreasure = async (nodeId) => {
  try {
    const response = await api.post(`/campaign/${nodeId}/treasure`, {});
    return response.data;
  } catch (error) {
    console.error(`Error opening treasure ${nodeId}:`, error);
    throw error;
  }
};

const campaignService = {
  getCampaign,
  playNode,
  completeNode,
  chooseEvent,
  openTreasure,
};

export default campaignService;
